import { get } from "../../service/api";

const getFunctionCalls = async () => {
  try {
    const response = await get(`/ai/functionCalls`);
    return response;
  } catch (error) {
    console.error("Error getFunctionCalls:", error);
    throw error;
  }
};

export default getFunctionCalls;
